import { zUid } from "src/types/zUid";
import z from "zod";

export const zBsRegSettings = z.object({
  url: z.string().nullable(),
  roleId: zUid.nullable(),
  stateId: zUid.nullable(),
  successMessage: z.string().nullable(),
  isAutoCreate: z.boolean().nullable(), // Это поле больше не используется, но оставлено для совместимости.
  createUserRoleId: zUid.nullable(),
});

export type ZBsRegSettings = z.infer<typeof zBsRegSettings>;
